import React from 'react'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'
import { Row, Col, LocaleProvider } from 'antd'

import { routes } from '_src/config'

import { parseArr, getRoutes } from '_src/utils/tool'
import '../style/common.less'

class ERouter extends React.Component {

  render () {
    return (
      <Row className="content">
      <HashRouter>
        <Switch>
            {parseArr(getRoutes(routes)).map((item)=>(
              <Route key = {item.path} path={item.path} exact={item.exact || false} component={item.component} />
            ))}
            <Redirect to="/home" />         
        </Switch>
      </HashRouter>
      </Row>
    )
  }
}
export default ERouter